(() => {
  const mediaSelector = 'img, video';

  const isProtectedMedia = (target) =>
    target instanceof Element && Boolean(target.closest(mediaSelector));

  const protectVideo = (video) => {
    video.setAttribute('controlsList', 'nodownload');
    video.setAttribute('disablePictureInPicture', '');
  };

  const protectVideos = () => document.querySelectorAll('video').forEach(protectVideo);

  document.addEventListener('contextmenu', (event) => {
    if (isProtectedMedia(event.target)) event.preventDefault();
  });

  document.addEventListener('dragstart', (event) => {
    if (isProtectedMedia(event.target)) event.preventDefault();
  });

  document.addEventListener('DOMContentLoaded', protectVideos, { once: true });

  // Capture dynamically inserted Shopify videos without observing every DOM mutation.
  document.addEventListener(
    'loadedmetadata',
    (event) => {
      if (event.target instanceof HTMLVideoElement) protectVideo(event.target);
    },
    true
  );
})();
